import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutPageComponent } from './about/about-page.component';

export const routes: Routes = [
  {
    path: 'about',
    component: AboutPageComponent,
    data: {
      caption: 'About',
    },
  },
  {
    path: '',
    redirectTo: 'about',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ResourceCenterRoutingModule {}
